import React, { useState, useEffect, forwardRef } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

// core components
import MaterialTable from "material-table";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { getConfigAsync } from "services/config";
import CircularProgress from "components/Circular/Circular";
import { updateConfigAsync } from "services/config";
import { getDocumentsAsync, createDocumentAsync, deleteDocumentAsync, updateDocumentAsync } from "services/document"
import Table from "components/Table/Table.js";

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

/* 
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
}; */

class Configuracoes extends React.Component {
  
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.handleSerieRPS = this.handleSerieRPS.bind(this);
    this.handleCnpjEmitente = this.handleCnpjEmitente.bind(this);
    this.handleValor = this.handleValor.bind(this);
    this.handleValorAdicional = this.handleValorAdicional.bind(this);
    this.handleIntervalo = this.handleIntervalo.bind(this);
    this.handleTolerancia = this.handleTolerancia.bind(this);
    this.handleRpsHeader = this.handleRpsHeader.bind(this);
    this.handleRpsFouter = this.handleRpsFouter.bind(this);
    this.handleTicketFouter = this.handleTicketFouter.bind(this);

    
    this.state = {
      config: [],
      document: [],
      circular: true,
      serieRPS: 0,
      cnpjEmitente: '',
      tocketFouter: '',
      rpsHeader: '',
      rpsFouter: '',
      intervalo: 0,
      valor: 0.0,
      valorAdicional: 0.0,
      open: false,
      columns: [
        { title: 'Nome', field: 'name' },
        { title: 'Descrição', field: 'description' },

      ],
      data: '',
      localization: {
        toolbar: {
          searchTooltip: 'Pesquisa',
          searchPlaceholder: 'Pesquisa'
        },
        header: {
          actions: "Ações"
        }

      }
    }
  }
  //const classes = useStyles();
  async componentDidMount() {
    let _config = await getConfigAsync();
    let _document = await getDocumentsAsync();
    this.setState({
      data: _document,
      config: _config,
      valor: _config.valorServico,
      valorAdicional: _config.valorServicoAdicional,
      intervalo: _config.intervalo,
      tolerancia: _config.tolerancia,
      cnpjEmitente: _config.cnpjEmitente,
      ticketFouter: _config.ticketFouter,
      rpsHeader: _config.rpsHeader,
      rpsFouter: _config.rpsFouter,
      circular: false
    });

  }

  componentDidUpdate(prevProps, prevState) {
     // only update chart if the data has changed
  if (prevProps.data !== this.props.data) {
    this.tableRef.current.onQueryChange();

  }
  }

  Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  handleSerieRPS = event => {
    this.setState({ serieRPS: event.target.value })
    let config = this.state.config;
    config.serieRps = event.target.value;
    this.setState({ config });
  }
  handleCnpjEmitente = event => {
    this.setState({ cnpjEmitente: event.target.value })
    let config = this.state.config;
    config.cnpjEmitente = event.target.value;
    this.setState({ config });
  }
  handleValor = event => {
    this.setState({ valorServico: event.target.value })
    let config = this.state.config;
    config.valorServico = event.target.value;
    this.setState({ config });
  }
  handleValorAdicional = event => {
    this.setState({ valorServicoAdicional: event.target.value })
    let config = this.state.config;
    config.valorServicoAdicional = event.target.value;
    this.setState({ config });
  }
  handleIntervalo = event => {
    this.setState({ intervalo: event.target.value })
    let config = this.state.config;
    config.intervalo = event.target.value;
    this.setState({ config });
  }
  handleTolerancia = event => {
    this.setState({ tolerancia: event.target.value })
    let config = this.state.config;
    config.tolerancia = event.target.value;
    this.setState({ config });
  }
  handleTicketFouter = event => {
    this.setState({ ticketFouter: event.target.value })
    let config = this.state.config;
    config.ticketFouter = event.target.value;
    this.setState({ config });
  }
  handleRpsHeader = event => {
    this.setState({ rpsHeader: event.target.value })
    let config = this.state.config;
    config.rpsHeader = event.target.value;
    this.setState({ config });
  }
  handleRpsFouter = event => {
    this.setState({ rpsFouter: event.target.value })
    let config = this.state.config;
    config.rpsFouter = event.target.value;
    this.setState({ config });
  }

  handleSubmit = async () => {
    try {

      let response = await updateConfigAsync(this.state.config);

      this.setState({ open: true });

    } catch (error) {
      console.log(error);
    }

  }

  handleClose = (event, reason) => {
    if (reason ==='clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    return ((this.state.circular) ?
      <div>
        <CircularProgress />
      </div>
      :
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 >Configurações</h4>
                <p >Cadastro de Parâmetros</p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Série da RPS"
                      id="serieRps"
                      value={this.state.serieRPS}

                      inputProps={{
                        value: this.state.serieRPS,
                        disableAnimation: true,
                        onChange: this.handleSerieRPS
                      }}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="CNPJ Emitente"
                      id="cnpjEmitente"
                      inputProps={{
                        value: this.state.cnpjEmitente,
                        disableAnimation: true,
                        onChange: this.handleCnpjEmitente
                      }}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Valor do Serviço"
                      id="valor-servico"
                      inputProps={{
                        value: this.state.valor,
                        disableAnimation: true,
                        onChange: this.handleValor
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Valor do Serviço Adicional"
                      id="valor-servico-adicional"
                      inputProps={{
                        value: this.state.valorAdicional,
                        disableAnimation: true,
                        onChange: this.handleValorAdicional
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>

                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Intervalo"
                      id="intervalo"
                      inputProps={{
                        value: this.state.intervalo,
                        disableAnimation: true,
                        onChange: this.handleIntervalo
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Tolerância"
                      id="tolerancia"
                      inputProps={{
                        value: this.state.tolerancia,
                        disableAnimation: true,
                        onChange: this.handleTolerancia
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>


                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Cabeçalho do RPS"
                      id="rpsHeader"
                      inputProps={{
                        value: this.state.rpsHeader,
                        disableAnimation: true,
                        onChange: this.handleRpsHeader,
                        multiline: true,
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Rodapé do RPS"
                      id="rpsFouter"
                      inputProps={{
                        value: this.state.rpsFouter,
                        disableAnimation: true,
                        onChange: this.handleRpsFouter,
                        multiline: true,
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Rodapé do Ticket"
                      id="ticketFouter"
                      inputProps={{
                        value: this.state.ticketFouter,
                        disableAnimation: true,
                        onChange: this.handleTicketFouter,
                        multiline: true,
                      }}

                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={'auto'} sm={'auto'} md={12}>
                    <MaterialTable
                      tableRef={this.tableRef}
                      localization={{
                        toolbar: {
                          searchTooltip: 'Pesquisa',
                          searchPlaceholder: 'Pesquisa'
                        },
                        header: {
                          actions: "Ações"
                        },
                        pagination: {
                          labelRowsSelect: "Linhas"
                        },
                        body: {
                          editRow: {
                            deleteText: "Confirma a exclusão dessa linha?"
                          }
                        }
                      }}

                      icons={tableIcons}
                      title="Tipos de Documentos"
                      columns={this.state.columns}
                      data={this.state.data ? this.state.data : ''}
                      editable={{
                        onRowAdd: newData =>
                          new Promise((resolve, reject) => {
                            setTimeout(() => {
                              {
                                createDocumentAsync(newData)
                                this.componentDidMount();
                                  
                                resolve();
                              }
                              resolve()
                            }, 1000)
                          }),
                        onRowUpdate: (newData, oldData) =>
                          new Promise((resolve, reject) => {
                            updateDocumentAsync(oldData.id, newData);

                            setTimeout(() => {
                              this.componentDidMount();

                              resolve();  
                            }, 200)
                          }),
                        onRowDelete: oldData =>
                          new Promise((resolve, reject) => {
                            setTimeout(() => {
                              {
                                deleteDocumentAsync(oldData.id);
                                this.componentDidMount();

                                resolve();
                              }
                              resolve()
                            }, 1000)
                          }),
                      }}
                    />
                  </GridItem>
                </GridContainer>

              </CardBody>
              <CardFooter>
                <Button onClick={this.handleSubmit} color="primary">Atualiza paramêtros</Button>
              </CardFooter>
            </Card>
            <Snackbar open={this.state.open} autoHideDuration={6000} onClose={this.handleClose}>
              <MuiAlert onClose={this.handleClose} severity="success">
                Paramêtros atualizados com sucesso!
        </MuiAlert>
            </Snackbar>
          </GridItem>

        </GridContainer>
      </div>)
  }
}

export default withStyles(styles)(Configuracoes);
